// Load a generated game.js in the page. A blob module cannot resolve the bare "#runtime"
// specifier, so the import line is rewritten to read defineEntity from a global the runtime
// sets, and loadModule drains the registrations as usual. Only the creator's own browser ever
// runs a module this way; published games are bundled like any other.

import { defineEntity, loadModule, type GameModule } from "../contract.js";

declare global {
  interface Window {
    __p2mRuntime?: { defineEntity: typeof defineEntity };
  }
}

const IMPORT_LINE = /^\s*import\s*\{([^}]*)\}\s*from\s*["']#runtime["']\s*;?/m;

/** Rewrite the one allowed import so the module can run from a blob URL. */
export function rewriteForBlob(source: string): string {
  if (!IMPORT_LINE.test(source)) throw new Error('the module must import { defineEntity } from "#runtime"');
  return source.replace(IMPORT_LINE, (_m, names: string) => `const {${names}} = globalThis.__p2mRuntime;`);
}

export async function loadGeneratedModule(source: string): Promise<GameModule> {
  window.__p2mRuntime = { defineEntity };
  const url = URL.createObjectURL(new Blob([rewriteForBlob(source)], { type: "text/javascript" }));
  try {
    return await loadModule(() => import(/* @vite-ignore */ url));
  } finally {
    URL.revokeObjectURL(url);
  }
}
